import request from './request'

/**
 * 获取产品类型列表
 */
export function getProductCategories() {
  return request.get('/product/categories')
}

/**
 * 创建产品类型
 * @param {object} data - 创建参数
 * @param {string} data.code - 类型编码
 * @param {string} data.name - 类型名称
 * @param {string} [data.icon] - 图标
 * @param {string} [data.description] - 描述
 * @param {number} [data.sort] - 排序
 * @param {number} [data.status] - 状态：1启用 0停用
 */
export function createProductCategory(data) {
  return request.post('/product/categories', data)
}

/**
 * 更新产品类型
 * @param {object} data - 更新参数
 * @param {number} data.id - 类型ID
 * @param {string} data.code - 类型编码
 * @param {string} data.name - 类型名称
 * @param {string} [data.icon] - 图标
 * @param {string} [data.description] - 描述
 * @param {number} [data.sort] - 排序
 * @param {number} [data.status] - 状态：1启用 0停用
 */
export function updateProductCategory(data) {
  return request.put('/product/categories', data)
}

/**
 * 删除产品类型
 * @param {number} id - 类型ID
 */
export function deleteProductCategory(id) {
  return request.delete(`/product/categories/${id}`)
}

/**
 * 分页查询产品列表
 * @param {object} data - 查询参数
 * @param {number} [data.categoryId] - 类型ID
 * @param {string} [data.keyword] - 关键字（名称/编码）
 * @param {number} [data.status] - 状态：1上架 0下架
 * @param {number} [data.page=1] - 页码
 * @param {number} [data.size=20] - 每页大小
 */
export function getProductPage(data) {
  return request.post('/product/page', data)
}

/**
 * 获取产品详情
 * @param {number} id - 产品ID
 */
export function getProductDetail(id) {
  return request.get(`/product/${id}`)
}

/**
 * 创建产品
 * @param {object} data - 创建参数
 * @param {string} data.name - 产品名称
 * @param {string} data.code - 产品编码
 * @param {number} data.categoryId - 类型ID
 * @param {string} [data.shortName] - 短名
 * @param {string} [data.icon] - 产品图标（文件key）
 * @param {number} [data.status] - 状态：1上架 0下架
 * @param {number} [data.needApproval] - 是否需要审批：1需要 0不需要
 */
export function createProduct(data) {
  return request.post('/product', data)
}

/**
 * 更新产品（生成新版本）
 * @param {object} data - 更新参数
 * @param {number} data.id - 产品ID
 * @param {string} [data.icon] - 产品图标（文件key）
 */
export function updateProduct(data) {
  return request.put('/product', data)
}

/**
 * 删除产品
 * @param {number} id - 产品ID
 */
export function deleteProduct(id) {
  return request.delete(`/product/${id}`)
}

/**
 * 创建临时产品
 * @param {object} data - 创建参数
 * @param {string} data.name - 临时产品名称
 */
export function createTemporaryProduct(data) {
  return request.post('/product/temporary', data)
}

/**
 * 获取产品树（类目+产品列表）
 * @param {number} [tenantId] - 租户ID，传0获取总部产品
 */
export function getProductTree(tenantId = 0) {
  return request.get('/product/tree', { params: { tenantId } })
}

/**
 * 设置产品热门状态
 * @param {object} data - 请求参数
 * @param {number} data.id - 产品ID
 * @param {number} data.isHot - 是否热门：1是 0否
 * @param {number} [data.hotSort] - 热门排序（值越小越靠前）
 */
export function setProductHot(data) {
  return request.put('/product/hot', data)
}

/**
 * 获取加盟商未被授权的产品树（总部产品中该加盟商尚未复制的部分）
 * @param {number} tenantId - 加盟商租户ID
 */
export function getUnauthorizedProductTree(tenantId) {
  return request.get('/product/unauthorized-tree', { params: { tenantId } })
}
